import { render } from "./RxPasswordView.vue?vue&type=template&id=8b7ca898&scoped=true"
import script from "./RxPasswordView.vue?vue&type=script&lang=js"
export * from "./RxPasswordView.vue?vue&type=script&lang=js"

import "./RxPasswordView.vue?vue&type=style&index=0&id=8b7ca898&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8b7ca898"]])

export default __exports__